import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

// import overrides from './overrides';
import palette from './palette';
import typography from './typography';

export const baseTheme = createMuiTheme({
  palette,
  typography,
  shape: {
    borderRadius: 8,
  },
});

const theme = {
  ...baseTheme,
  shadows: [...Array(25).keys()].map(i =>
    i === 0
      ? 'none'
      : `0 2px ${2.5 + i / 1.75}px 1px rgba(0, 0, 0, 0.14), 0 4px ${
          2.5 + i / 1.75
        }px -7px ${baseTheme.palette.background.default}`
  ),
  palette: {
    ...baseTheme.palette,
    primary: {
      ...baseTheme.palette.primary,
      // gradient: `linear-gradient(70deg, ${baseTheme.palette.primary.dark} 0%, ${baseTheme.palette.primary.light} 100%)`,
    },
    secondary: {
      ...baseTheme.palette.secondary,
      // gradient: `linear-gradient(70deg, ${baseTheme.palette.secondary.dark} 0%, ${baseTheme.palette.secondary.light} 100%)`,
    },
  },
  overrides: {
    MuiAppBar: {
      colorDefault: {
        backgroundColor: baseTheme.palette.background.default,
      },
      colorSecondary: {
        background: `linear-gradient(60deg, ${baseTheme.palette.secondary.main} 50%, ${baseTheme.palette.secondary.dark} 90%)`,
      },
      colorPrimary: {
        background: `linear-gradient(60deg, ${baseTheme.palette.primary.main} 50%, ${baseTheme.palette.primary.dark} 90%)`,
      },
    },
    MuiBottomNavigation: {
      root: {
        backgroundColor: baseTheme.palette.background.default,
      },
    },
    MuiButton: {
      label: {
        textTransform: 'initial',
      },
      containedPrimary: {
        // boxShadow: `0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 20px -5px ${baseTheme.palette.primary.main} !important`,
        // background: `linear-gradient(60deg, ${baseTheme.palette.primary.main} 50%, ${baseTheme.palette.primary.dark}) 90%`,
        // color: baseTheme.palette.getContrastText(
        //   baseTheme.palette.primary.main
        // ),
        '&$disabled': {
          boxShadow: 'none !important',
        },
      },
      containedSecondary: {
        // boxShadow: `0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 20px -5px ${baseTheme.palette.secondary.main} !important`,
        // background: `linear-gradient(60deg, ${baseTheme.palette.secondary.main} 50%, ${baseTheme.palette.secondary.dark}) 90%`,
        // color: baseTheme.palette.getContrastText(
        //   baseTheme.palette.secondary.main
        // ),
        '&$disabled': {
          boxShadow: 'none !important',
        },
      },
    },
    MuiBottomNavigationAction: {
      root: {
        // minWidth: 72,
        // color: 'transparent',
        // '&$selected': {
        //   color: 'transparent',
        //   paddingTop: 16,
        // },
      },
    },
    MuiInputBase: {
      root: {
        backgroundColor: baseTheme.palette.background.paper,
      },
    },
    // MuiOutlinedInput: {
    //   notchedOutline: {
    //     // border: 'none',
    //   },
    // },
    // PrivateNotchedOutline: {
    //   root: {
    //     top: 0,
    //   },
    //   legendLabelled: {
    //     display: 'none',
    //   },
    // },
    MuiFormControl: {
      marginNormal: {
        marginTop: baseTheme.spacing(3),
        marginBottom: baseTheme.spacing(1),
      },
    },
    MuiInputLabel: {
      shrink: {
        fontWeight: 500,
        // fontSize: baseTheme.spacing(2.5),
        // top: baseTheme.spacing(-2),
        // left: baseTheme.spacing(-0.5),
      },
    },
    MuiCssBaseline: {
      '@global': {
        body: {},
      },
    },
  },
};

export default responsiveFontSizes(theme);
